package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationType
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationDisease
import kotlin.collections.Set
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationInteriorPathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationExteriorPathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationIntermediatePathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationUpperPathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationMiddlePathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationLowerPathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationOverallPathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationZangfuPathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationZangfuCombinedPathogenesis
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationStatus
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class SyndromeIndication(var id: String? = null){
	var name: String? = null
	var syndromeId: String? = null
	var type: SyndromeIndicationType? = null
	var signSymptomBaseSyndromeId: String? = null
	var signSymptomBaseIndicationId: String? = null
	var source: String? = null
	var sourceContentId: String? = null
	var disease: Set<SyndromeIndicationDisease>? = null
	var interiorPathogenesis: Set<SyndromeIndicationInteriorPathogenesis>? = null
	var exteriorPathogenesis: Set<SyndromeIndicationExteriorPathogenesis>? = null
	var intermediatePathogenesis: Set<SyndromeIndicationIntermediatePathogenesis>? = null
	var upperPathogenesis: Set<SyndromeIndicationUpperPathogenesis>? = null
	var middlePathogenesis: Set<SyndromeIndicationMiddlePathogenesis>? = null
	var lowerPathogenesis: Set<SyndromeIndicationLowerPathogenesis>? = null
	var overallPathogenesis: Set<SyndromeIndicationOverallPathogenesis>? = null
	var zangfuPathogenesis: Set<SyndromeIndicationZangfuPathogenesis>? = null
	var zangfuCombinedPathogenesis: Set<SyndromeIndicationZangfuCombinedPathogenesis>? = null
	var pathogenesisOthers: String? = null
	var status: SyndromeIndicationStatus? = null
	var organizationId: String? = null
	var userId: String? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var description: String? = null
	var todo: String? = null
	var weight: Int? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SyndromeIndication
		if (id != other.id) return false
		if (name != other.name) return false
		if (syndromeId != other.syndromeId) return false
		if (type != other.type) return false
		if (signSymptomBaseSyndromeId != other.signSymptomBaseSyndromeId) return false
		if (signSymptomBaseIndicationId != other.signSymptomBaseIndicationId) return false
		if (source != other.source) return false
		if (sourceContentId != other.sourceContentId) return false
		if (disease != other.disease) return false
		if (interiorPathogenesis != other.interiorPathogenesis) return false
		if (exteriorPathogenesis != other.exteriorPathogenesis) return false
		if (intermediatePathogenesis != other.intermediatePathogenesis) return false
		if (upperPathogenesis != other.upperPathogenesis) return false
		if (middlePathogenesis != other.middlePathogenesis) return false
		if (lowerPathogenesis != other.lowerPathogenesis) return false
		if (overallPathogenesis != other.overallPathogenesis) return false
		if (zangfuPathogenesis != other.zangfuPathogenesis) return false
		if (zangfuCombinedPathogenesis != other.zangfuCombinedPathogenesis) return false
		if (pathogenesisOthers != other.pathogenesisOthers) return false
		if (status != other.status) return false
		if (organizationId != other.organizationId) return false
		if (userId != other.userId) return false
		if (createdBy != other.createdBy) return false
		if (createdOn != other.createdOn) return false
		if (description != other.description) return false
		if (todo != other.todo) return false
		if (weight != other.weight) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (syndromeId?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (signSymptomBaseSyndromeId?.hashCode() ?: 0)
		result = 31 * result + (signSymptomBaseIndicationId?.hashCode() ?: 0)
		result = 31 * result + (source?.hashCode() ?: 0)
		result = 31 * result + (sourceContentId?.hashCode() ?: 0)
		result = 31 * result + (disease?.hashCode() ?: 0)
		result = 31 * result + (interiorPathogenesis?.hashCode() ?: 0)
		result = 31 * result + (exteriorPathogenesis?.hashCode() ?: 0)
		result = 31 * result + (intermediatePathogenesis?.hashCode() ?: 0)
		result = 31 * result + (upperPathogenesis?.hashCode() ?: 0)
		result = 31 * result + (middlePathogenesis?.hashCode() ?: 0)
		result = 31 * result + (lowerPathogenesis?.hashCode() ?: 0)
		result = 31 * result + (overallPathogenesis?.hashCode() ?: 0)
		result = 31 * result + (zangfuPathogenesis?.hashCode() ?: 0)
		result = 31 * result + (zangfuCombinedPathogenesis?.hashCode() ?: 0)
		result = 31 * result + (pathogenesisOthers?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (organizationId?.hashCode() ?: 0)
		result = 31 * result + (userId?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (todo?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		return result
	}

}
